import React from 'react';
import { Component } from 'react';
import { DownloadButtons } from '../../Buttons/Download/DownloadButtons';
import './StartScreen.css';

export default class StartScreen extends Component {
    public render() {
        return (
            <div className="start-container">
                <div className="row">
                    <div className="col">
                        <div className="title">
                            <p>Mediti:</p>
                        </div>
                        <div className="subtitle">
                            <p><span className="gold-text">Metoda medytacyjna</span> stanowiąca połączenie różnych form medytacji, technik oddechowych, autohipnozy oraz uważności.</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <DownloadButtons />
                    </div>
                </div>


            </div>
        )
    }
}